import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('action-submit', (editor, opts) => {
  const default_types = {
    actionSubmit: 'action-submit',
  };
  const default_labels = {
    actionSubmit: 'Action Submit',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelActionSubmitCategory: 'Forms',
    },
    ...opts,
  };
  loadComponents(editor, options);
});
